import React from 'react';
import parse from 'html-react-parser';

// Same as home Hero overlay so bg image is visible in the back ($primaryDark / $bodyBg)
const HERO_STYLE_OVERLAY = 'linear-gradient(135deg, rgba(3, 16, 30, 0.92) 0%, rgba(10, 15, 26, 0.85) 100%)';

export default function BannerSectionStyle2({ bgUrl, title, subTitle }) {
  return (
    <div className="container">
      <div
        className="cs_banner cs_style_2 cs_radius_25 cs_bg_filed"
        style={{ 
          backgroundImage: `${HERO_STYLE_OVERLAY}, url(${bgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          imageRendering: 'auto',
          willChange: 'auto'
        }}
      >
        <div className="cs_section_heading cs_style_1">
          <h2 className="cs_section_title cs_fs_72 m-0 cs_white_color">
            {parse(title)}
          </h2>
          <div className="cs_height_22" />
          <p className="m-0 cs_white_color cs_fs_20 cs_medium">
            {parse(subTitle)}
          </p>
        </div>
      </div>
    </div>
  );
}
